"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Log = void 0;
var _runtime = require("../../../common/constants/runtime");
var _cleanUrl = require("../../../common/url/clean-url");
var _constants = require("../constants");
class Log {
  /** @type {long} the unix timestamp of the log event */
  timestamp;
  /** @type {string} the log message */
  message;
  /** @type {object} the object of attributes to be parsed by logging ingest into top-level properties */
  attributes;
  /** @type {'ERROR'|'TRACE'|'DEBUG'|'INFO'|'WARN'} the log type of the log */
  level;

  /**
   * @param {number} timestamp - Unix timestamp
   * @param {string} message - message string
   * @param {object} attributes - other log event attributes
   * @param {enum} level - Log level
   */
  constructor(timestamp, message, attributes = {}, level = _constants.LOG_LEVELS.INFO) {
    /** @type {long} */
    this.timestamp = timestamp;
    this.message = message;
    this.attributes = {
      ...attributes,
      pageUrl: (0, _cleanUrl.cleanURL)('' + _runtime.globalScope.location)
    };
    this.level = level.toUpperCase();
  }
}
exports.Log = Log;